import { Greetings } from 'aws-amplify-react';
import React from 'react';
import Button from '../Button';
import ContainerDefault from '../Container';
import Row from '../Row';

const Container = ContainerDefault.extend`
    margin-top: 2em;
`;

export default class CustomGreetings extends Greetings {
    public render() {
        const { authState } = this.props;

        if (!['signedIn'].includes(authState)) {
            return null;
        }

        return (
            <Container>
                <Row>
                    <div />
                    <Button normal onClick={this.signOut}>
                        Sign Out
                    </Button>
                </Row>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cognito/CustomGreetings.tsx